/* Laqqua – Enhancements widget Shopify Subscriptions (stile "toggle")
 * - Etichette piani brevi e ordinate (Ogni 3/4/5 settimane)
 * - Badge sconto sulla tab Abbonamento (calcolato dai prezzi, vale per ogni %)
 * - Prezzi senza suffisso "EUR"
 * - Sync del prezzo principale della PDP con l'opzione selezionata
 * Il markup è generato dall'app: tutto è feature-detected e fallisce in silenzio.
 */
(function () {
  'use strict';

  var BADGE_CLASS = 'laqqua-subs-badge';

  function parsePrice(str) {
    if (!str) return null;
    var n = str.replace(/[^\d,.]/g, '');
    if (!n) return null;
    n = n.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(n);
    return isNaN(v) ? null : v;
  }

  function stripEur(str) {
    return (str || '').replace(/\s*EUR\s*$/, '').trim();
  }

  function cleanPrices(container) {
    var els = container.querySelectorAll('.price, .tab_price_compare, .in_widget_price');
    els.forEach(function (el) {
      if (el.children.length) return;
      var cleaned = stripEur(el.textContent);
      if (cleaned !== el.textContent.trim()) el.textContent = cleaned;
    });
  }

  function shortenPlanLabels(container) {
    container.querySelectorAll('.group_list span').forEach(function (sp) {
      if (sp.children.length) return;
      var m = sp.textContent.match(/ogni\s+(\d+)\s+settiman[ae]/i);
      if (m) {
        var label = 'Ricevi il prodotto ogni ' + m[1] + ' settimane';
        if (sp.textContent.trim() !== label) sp.textContent = label;
      }
    });
  }

  function sortPlans(container) {
    container.querySelectorAll('.group_list').forEach(function (ul) {
      var lis = Array.prototype.slice.call(ul.children);
      var weeks = function (li) {
        var m = (li.textContent || '').match(/(\d+)\s*settiman/i);
        return m ? parseInt(m[1], 10) : 999;
      };
      lis
        .sort(function (a, b) {
          return weeks(a) - weeks(b);
        })
        .forEach(function (li) {
          ul.appendChild(li);
        });
    });
  }

  function addBadge(container) {
    var label = container.querySelector('label[id^="subscribe_panel_label"] > span:first-child');
    if (!label || label.querySelector('.' + BADGE_CLASS)) return;
    var plan = container.querySelector('input[data-radio-type="selling_plan"]');
    if (!plan) return;
    var price = parsePrice(plan.dataset.variantPrice);
    var compare = parsePrice(plan.dataset.variantCompareAtPrice);
    if (!price || !compare || compare <= price) return;
    var pct = Math.round((1 - price / compare) * 100);
    if (pct < 1) return;
    var b = document.createElement('span');
    b.className = BADGE_CLASS;
    b.textContent = '−' + pct + '%';
    label.appendChild(b);
  }

  /* ---- Popup "Come funziona l'abbonamento" ----
     Contenuti verificati sul checkout reale (2026-06-11): con un abbonamento
     nel carrello restano carta + Shop Pay/Google Pay/Apple Pay; PayPal, Klarna
     e contrassegno non sono disponibili. I codici sconto non si applicano ai
     prodotti in abbonamento. Gestione da account: pausa/salta/annulla. */
  var MODAL_ID = 'laqqua-subs-modal';

  function getModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'laqqua-subs-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="laqqua-subs-modal__backdrop" data-subs-modal-close></div>' +
      '<div class="laqqua-subs-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="laqqua-subs-modal-title">' +
      '<button type="button" class="laqqua-subs-modal__close" data-subs-modal-close aria-label="Chiudi">&#10005;</button>' +
      '<h3 id="laqqua-subs-modal-title">Come funziona l’abbonamento</h3>' +
      '<ul>' +
      '<li><strong>Consegne automatiche.</strong> Ricevi il prodotto con la frequenza che scegli, sempre con il prezzo scontato dell’abbonamento.</li>' +
      '<li><strong>Spedizione gratuita.</strong> Gli ordini composti solo da abbonamenti non pagano mai la spedizione, nemmeno i rinnovi. Negli ordini misti vale la soglia dei 49€.</li>' +
      '<li><strong>Paghi solo a ogni consegna.</strong> Nessun costo anticipato: l’addebito avviene sul metodo di pagamento salvato quando parte l’ordine, e ricevi la conferma via email.</li>' +
      '<li><strong>Nessun vincolo.</strong> Metti in pausa, salti una consegna o annulli quando vuoi dal tuo account, senza penali. L’annullamento è immediato.</li>' +
      '<li><strong>Pagamenti.</strong> Puoi usare carta di credito o debito e i wallet (Shop Pay, Google Pay, Apple Pay). PayPal, Klarna e il pagamento alla consegna non sono disponibili per gli abbonamenti.</li>' +
      '<li><strong>Sconti.</strong> Lo sconto abbonamento è incluso a ogni rinnovo. Eventuali codici sconto non si applicano ai prodotti in abbonamento.</li>' +
      '</ul>' +
      '<p class="laqqua-subs-modal__footnote">Gestisci tutto da <a href="/account">Il mio account personale</a>.</p>' +
      '</div>';
    document.body.appendChild(modal);

    var lastFocus = null;

    function close() {
      modal.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      if (lastFocus) lastFocus.focus();
    }

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-subs-modal-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    modal.laqquaOpen = function () {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('.laqqua-subs-modal__close').focus();
    };

    return modal;
  }

  function injectInfoLink(container) {
    var policy = container.querySelector('.shopify_subscriptions_app_policy');
    if (!policy || policy.querySelector('.laqqua-subs-info-link')) return;
    /* Riscrive il testo dell'app per includere la spedizione gratuita
       (sconto automatico "Spedizione gratuita abbonamenti", attivo dal 2026-06-12) */
    if (policy.firstChild && policy.firstChild.nodeType === 3) {
      policy.firstChild.textContent =
        'Spedizione gratuita a ogni rinnovo. Salta o annulla quando vuoi.';
    }
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'laqqua-subs-info-link';
    link.textContent = 'Come funziona?';
    link.addEventListener('click', function () {
      getModal().laqquaOpen();
    });
    policy.appendChild(document.createTextNode(' '));
    policy.appendChild(link);
  }

  /* ---- Prezzo principale PDP ----
     L'app ha due modalita' (app-block.js): se nel section esistono SIA
     .price__regular SIA .price__sale usa il "theme mode" (updateThemePrice:
     mostra il sale, nasconde il regular, aggiunge price--on-sale) — ma al
     ritorno su "Acquisto singolo" NON ripristina nulla (listenToOtpTabClick
     non chiama updatePrice). Altrimenti usa solo i prezzi in-widget.
     Strategia: snapshot dello stato prezzo al load; su abbonamento lasciamo
     fare all'app (theme mode) o iniettiamo noi (widget mode); su acquisto
     singolo ripristiniamo integralmente lo snapshot. */
  function buildPriceSnapshot(root) {
    var save = function (el) {
      return { el: el, d: el.style.display, h: el.innerHTML };
    };
    return {
      regs: Array.prototype.map.call(root.querySelectorAll('.price__regular'), save),
      sales: Array.prototype.map.call(root.querySelectorAll('.price__sale'), save),
      prices: Array.prototype.map.call(root.querySelectorAll('.price'), function (el) {
        return { el: el, onSale: el.classList.contains('price--on-sale') };
      })
    };
  }

  function restorePriceSnapshot(snap) {
    snap.regs.concat(snap.sales).forEach(function (s) {
      s.el.style.display = s.d;
      s.el.innerHTML = s.h;
    });
    snap.prices.forEach(function (s) {
      s.el.classList.toggle('price--on-sale', s.onSale);
    });
  }

  function syncMainPrice(container) {
    var root = container.closest('[id^="shopify-section-"]') || document;
    if (!container.laqquaPriceSnap) {
      container.laqquaPriceSnap = buildPriceSnapshot(root);
    }
    var snap = container.laqquaPriceSnap;
    /* Stessa condizione con cui l'app sceglie il theme mode */
    var appThemeMode = snap.regs.length > 0 && snap.sales.length > 0;

    var subTab = container.querySelector('input[id^="tab_subscribe_"]');
    var visible =
      container.querySelector(
        'section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)'
      ) || container;
    var checked = visible.querySelector('input[data-radio-type="selling_plan"]:checked');

    if (subTab && subTab.checked && checked) {
      if (appThemeMode) return; /* ci pensa l'app */
      var priceEl =
        root.querySelector('.price__regular .price-item--regular') ||
        root.querySelector('.price-item--regular');
      if (!priceEl) return;
      while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
      priceEl.appendChild(document.createTextNode(stripEur(checked.dataset.variantPrice)));
      var cmp = stripEur(checked.dataset.variantCompareAtPrice);
      if (cmp && cmp !== stripEur(checked.dataset.variantPrice)) {
        var s = document.createElement('s');
        s.className = 'laqqua-subs-compare';
        s.textContent = cmp;
        priceEl.appendChild(s);
      }
    } else {
      /* Acquisto singolo: ripristina lo stato originale del blocco prezzo,
         qualunque cosa l'app o noi abbiamo toccato. */
      restorePriceSnapshot(snap);
    }
  }

  function setup(container) {
    if (container.dataset.laqquaEnhanced) return;
    container.dataset.laqquaEnhanced = '1';

    /* Il primo piano nell'ordine del merchant (pre-sort) è il default voluto:
       l'app auto-seleziona il primo nel DOM, che dopo il sort cambierebbe. */
    var defaultPlanId = container.querySelector('input[data-radio-type="selling_plan"]')
      ? container.querySelector('input[data-radio-type="selling_plan"]').dataset.sellingPlanId
      : null;
    var defaultApplied = false;

    shortenPlanLabels(container);
    sortPlans(container);
    addBadge(container);
    cleanPrices(container);
    injectInfoLink(container);

    /* Snapshot SUBITO, prima di qualsiasi interazione: se lo facessimo al
       primo change, l'app avrebbe gia' modificato il blocco prezzo e il
       ripristino congelerebbe lo stato sbagliato. */
    container.laqquaPriceSnap = buildPriceSnapshot(
      container.closest('[id^="shopify-section-"]') || document
    );

    /* FIX bug app (stile toggle): tornando su "Acquisto singolo" l'app disabilita
       i radio dei piani ma NON azzera gli input hidden .selected-selling-plan-id
       (listenToOtpTabClick non chiama updateSellingPlanInputsValues), quindi
       l'add-to-cart aggiungerebbe comunque l'abbonamento. Li azzeriamo noi. */
    var otpTab = container.querySelector('input[id^="tab_otp_"]');
    if (otpTab) {
      otpTab.addEventListener('change', function () {
        window.setTimeout(function () {
          if (!otpTab.checked) return;
          var root = container.closest('[id^="shopify-section-"]') || document;
          root.querySelectorAll('.selected-selling-plan-id').forEach(function (inp) {
            inp.value = '';
          });
        }, 0);
      });
    }

    var subTab = container.querySelector('input[id^="tab_subscribe_"]');
    if (subTab && defaultPlanId) {
      subTab.addEventListener('change', function () {
        if (defaultApplied || !subTab.checked) return;
        defaultApplied = true;
        window.setTimeout(function () {
          var def = container.querySelector(
            'input[data-radio-type="selling_plan"][data-selling-plan-id="' + defaultPlanId + '"]'
          );
          if (def && !def.checked && !def.disabled) {
            def.checked = true;
            def.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 0);
      });
    }

    /* setTimeout: lascia prima lavorare il JS dell'app (seleziona il piano,
       aggiorna l'input hidden), poi leggiamo lo stato risultante. */
    container.addEventListener('change', function () {
      window.setTimeout(function () {
        cleanPrices(container);
        syncMainPrice(container);
      }, 0);
    });

    /* L'app riscrive i prezzi al cambio variante: rinormalizziamo.
       disconnect/observe evita il loop con le nostre stesse mutazioni. */
    var mo = new MutationObserver(function () {
      mo.disconnect();
      cleanPrices(container);
      shortenPlanLabels(container);
      observe();
    });
    var observe = function () {
      mo.observe(container, { subtree: true, childList: true, characterData: true });
    };
    observe();
  }

  function init() {
    document.querySelectorAll('.shopify_subscriptions_app_container').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
